import { Checkbox_ } from 'monica-alexandria';
import styled from 'styled-components';
import Offer_Preview_Payment_Action from './Offer_Preview_Payment_Action';

const OfferPreviewAcceptance = styled.div`
    margin-top: 1.4rem;
    padding: 1.6rem;
    border: 0.1rem solid ${p => p.theme.mid};
    border-radius: var(--smallRadius);
    background: linear-gradient(140deg, ${p => p.theme.background} 0%, ${p => p.theme.low} 100%);
    display: grid;
    gap: 1.2rem;

    @media print {
        display: none;
    }
`;

const OfferPreviewAcceptanceHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
`;

const OfferPreviewAcceptanceState = styled.h6`
    margin: 0;
    padding: 0.5rem 0.9rem;
    border-radius: var(--smallRadius);
    background: ${p => p.active ? 'var(--success)' : p.theme.mid};
    color: ${p => p.active ? p.theme.flare : p.theme.color};
`;

const OfferPreviewAcceptanceChoice = styled.div`
    padding: 1rem;
    border: 0.1rem solid ${p => p.theme.mid};
    border-radius: var(--smallRadius);
    background: ${p => p.theme.background};
`;

const OfferPreviewActionRow = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
    padding-top: 0.4rem;
    border-top: 0.1rem dashed ${p => p.theme.mid};
`;

const OfferPreviewUnavailable = styled.div`
    margin-top: 1.4rem;
    padding: 1.6rem;
    border: 0.1rem solid ${p => p.theme.mid};
    border-radius: var(--smallRadius);
    background: linear-gradient(140deg, ${p => p.theme.background} 0%, ${p => p.theme.low} 100%);
    display: grid;
    gap: 0.8rem;

    @media print {
        display: none;
    }
`;

export default function Offer_Preview_Payment(props) {
    return (
        <>
            {props.offerUnavailable ? (
                <OfferPreviewUnavailable>
                    <h4>{props.copy.unavailableTitle}</h4>
                    <p>{props.copy.unavailableText}</p>
                </OfferPreviewUnavailable>
            ) : (
                <OfferPreviewAcceptance>
                    <OfferPreviewAcceptanceHeader>
                        <h4>{props.copy.acceptanceTitle}</h4>
                        <OfferPreviewAcceptanceState active={props.termsAccepted}>
                            {props.termsAccepted ? props.copy.acceptanceAccepted : props.copy.acceptancePending}
                        </OfferPreviewAcceptanceState>
                    </OfferPreviewAcceptanceHeader>
                    <OfferPreviewAcceptanceChoice>
                        <Checkbox_
                            id="offer-preview-terms"
                            text={props.copy.acceptanceText}
                            checked={props.termsAccepted}
                            onChange={props.onTermsChange}
                        ></Checkbox_>
                    </OfferPreviewAcceptanceChoice>
                    {props.termsAccepted ? (
                        <OfferPreviewActionRow>
                            {props.paymentOverview.hasRecurring ? (
                                <Offer_Preview_Payment_Action
                                    copy={props.copy}
                                    paymentType="recurring"
                                    paymentText={props.copy.proceedRecurringPayment}
                                    paymentLinkUrl={props.paymentOverview.recurringPaymentLinkUrl}
                                    usesBankTransfer={props.paymentOverview.recurringUsesBankTransfer}
                                    isInitiating={props.isInitiating}
                                    onProceed={props.onProceed}
                                    onProceedToLink={props.onProceedToLink}
                                ></Offer_Preview_Payment_Action>
                            ) : null}
                            {props.paymentOverview.hasOneOff ? (
                                <Offer_Preview_Payment_Action
                                    copy={props.copy}
                                    paymentType="one_off"
                                    paymentText={props.copy.proceedOneOffPayment}
                                    paymentLinkUrl={props.paymentOverview.oneOffPaymentLinkUrl}
                                    usesBankTransfer={props.paymentOverview.oneOffUsesBankTransfer}
                                    isInitiating={props.isInitiating}
                                    onProceed={props.onProceed}
                                    onProceedToLink={props.onProceedToLink}
                                ></Offer_Preview_Payment_Action>
                            ) : null}
                        </OfferPreviewActionRow>
                    ) : null}
                    {props.errorMessage ? <p>{props.errorMessage}</p> : null}
                </OfferPreviewAcceptance>
            )}
        </>
    );
}
